import TimerModeDescription from './TimerModeDescription'

export default TimerModeDescription
